import { useState, useEffect } from "react";
import Pagination from "@react/widget/Pagination";

export interface Entry {
  title: string;
  url: string;
  ArticleID?: string;
  avepointProducts?: string[];
  productVersions?: string[];
  sharepointVersions?: string[];
}

interface Props {
  entryCount: number;
  entries: Entry[];
  label: Record<string, any>;
}

export default function KbPageation({ entryCount, entries = [], label }: Props) {
  const total = Math.ceil(entryCount / 10);
  const [page, setPage] = useState(1);
  const [currentEntries, setCurrentEntries] = useState<Entry[]>([]);

  const paginate = (page: number) => {
    const start = (page - 1) * 10;
    const end = start + 10;
    return entries.slice(start, end);
  };

  useEffect(() => {
    setCurrentEntries(paginate(page));
  }, [page, entries]);

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  return (
    <>
      {entryCount > 0 ? <ul className="[&>li:not(last-child)]:border-b border-t mx-auto">
        {currentEntries.map(({ title, url, ArticleID, avepointProducts, productVersions, sharepointVersions }) => (
          <li key={title} className="py-7.5">
            <a href={url} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between w-full pb-6 gap-6 transition duration-300 rounded-full hover:text-primary-hover cursor-pointer">
              <h3 className="text-lg">{title}</h3>
            </a>
            <p>
              {!!ArticleID && <><span className="font-semibold">KB Article ID:</span><span className="pr-10"> {ArticleID}</span></>}
              {!!avepointProducts && <><span className="font-semibold">Product:</span><span> {avepointProducts.toString()}</span></>}
            </p>
            <p className="mt-1">
              {!!productVersions && <><span className="font-semibold">Product Version:</span><span className="pr-10"> {productVersions.toString()}</span></>}
              {!!sharepointVersions && <><span className="font-semibold">SharePoint Version:</span><span> {sharepointVersions.toString()}</span></>}
            </p>
          </li>
        ))}
      </ul> : <p>Sorry, no corresponding Post was found. Please filter again.</p>}
      {(entryCount > 0 && total > 0) && (
        <Pagination label={label} page={page} total={total} onChange={e => handlePageChange(e)} />
      )}
    </>
  );
}